import * as React from "react";
import { ResponsiveBubble } from "@nivo/circle-packing";
import graphData from "../../assets/data/samplebubbledata";
import Modal from "react-awesome-modal";
import Vimeo from "@u-wave/react-vimeo";
//   Orange: f56f3f
// Red: e7233d
// Green: 18ee97
// Yellow: feb743
// Purple: 8e0666
//ana's colors ["#fe0033", "#acff24", "#3ee9f7"]
export default class BubbleChart extends React.Component {
  state = {
    modalOpen: false,
    videoId: "",
  };

  constructor(props) {
    super(props);
  }

  closeModal = () => {
    this.setState({ modalOpen: false, videoId: "" });
  };

  // openModal = (vidID) => {
  //   this.setState({ modalOpen: true, videoId: vidID });
  // }

  renderVimeo = () => {
    const { videoId, modalOpen } = this.state;

    let content = (
      <Vimeo
        responsive={true}
        className="postpayment-video"
        video={`https://player.vimeo.com/video/${this.state.videoId}`}
      />
    );
    if (videoId === "") {
      content = <p>This Behaviour has no video attached to it</p>;
    }
    return (
      <Modal
        height="360"
        width="640"
        visible={this.state.modalOpen}
        effect="fadeInDown"
        onClickAway={this.closeModal}
      >
        <div className="vid-wrapper">{content} </div>
      </Modal>
    );
  };

  render() {
    const {
      realData,
      identity,
      value,
      isReady,
      colorBy,
      disableLabel,
      leavesOnly,
    } = this.props;

    return (
      <div style={{ width: "100%", height: "100%" }} className="nivocontainer">
        {this.renderVimeo()}
        <ResponsiveBubble
          root={isReady ? realData : graphData}
          margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
          identity={isReady ? identity : "name"}
          value={isReady ? value : "students"}
          colors={["#fe0033", "#acff24", "#3ee9f7"]}
          padding={6}
          // label= {(d) => `${d.value} % of students chose ${d.id}`}
          labelTextColor={'{ "#fff", modifiers: [["darker", "1.5"]] }'}
          borderWidth={2}
          borderColor={{ from: "color" }}
          defs={[
            {
              id: "lines",
              type: "patternLines",
              background: "none",
              color: "inherit",
              rotation: -45,
              lineWidth: 5,
              spacing: 8,
            },
          ]}
          fill={[{ match: { depth: 0 }, id: "lines" }]}
          colorBy={colorBy || "depth"}
          animate={true}
          motionStiffness={100}
          motionDamping={14}
          disableLabel={disableLabel || true}
          isZoomable={false}
          leavesOnly={leavesOnly}
          tooltip={(d) => {
            return (
              <p>
                <strong>{d.id}</strong> <br />
                <span>Score: </span> {d.value}
              </p>
            );
          }}
          isInteractive={true}
          onClick={(node, e) => {
            this.setState({ modalOpen: true, videoId: node.data.vidID });
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/DataViz/bubbleChart.Component.js